import type { Row } from "@/components/positions/types";

/** Position aus einem Händler-Warenkorb (IDS Connect), so wie die API sie zurückgibt. */
export interface CartLine {
  supplierArticleNumber: string;
  name: string;
  quantity: number;
  unit: string;
  unitPriceCents: number;
}

/** Warenkorb-Positionen als Angebots-/Rechnungszeilen (Einkaufspreis des Händlers als Einzelpreis). */
export function cartLinesToRows(lines: CartLine[]): Row[] {
  return lines.map((l, i) => ({
    clientId: `pc_${i}_${Math.random().toString(36).slice(2)}`,
    parentClientId: null,
    kind: "position" as const,
    mode: "mandatory" as const,
    itemCategory: "material" as const,
    description: l.name,
    longText: l.supplierArticleNumber
      ? `Art.-Nr. ${l.supplierArticleNumber}`
      : "",
    quantity: l.quantity || 1,
    unit: l.unit || "Stk.",
    unitPriceCents: l.unitPriceCents || 0,
    discountPercent: 0,
    alternativeGroup: "",
    isChosenAlternative: false,
    rangeFromLabel: "",
    rangeToLabel: "",
    articleId: null,
    purchasePriceCents: null,
  }));
}

/** Shop-Fenster sofort (im Klick) öffnen, damit Popup-Blocker nicht zuschlagen, und später auf die Adresse setzen. */
export function openBlankShopWindow(): Window | null {
  const w = window.open("", "_blank");
  if (w) {
    try {
      w.document.title = "Händlershop wird geöffnet …";
      w.document.body.style.fontFamily = "system-ui";
      w.document.body.textContent = "Händlershop wird geöffnet …";
      w.opener = null;
    } catch {
      /* ignore */
    }
  }
  return w;
}
